var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mm-button", attrs: { loading: _vm.loading } },
    [
      _c(
        "el-popover",
        { attrs: { placement: "bottom-end", trigger: "hover" } },
        [
          _c(
            "div",
            { staticClass: "spaceLeft" },
            [
              _c("img", {
                staticClass: "mm-logo",
                attrs: { src: require("../../../assets/logo/mm-logo.png") },
              }),
              _vm._v(" "),
              _vm.account
                ? _c("account", {
                    staticClass: "mm-text",
                    attrs: { value: _vm.account },
                  })
                : _c(
                    "el-button",
                    {
                      staticClass: "mm-text",
                      attrs: { type: "text" },
                      on: { click: _vm.connectMetaMask },
                    },
                    [_vm._v(_vm._s(_vm.btnText))]
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
            _vm.btnText == "Connected"
              ? _c("img", {
                  staticClass: "asset-img",
                  attrs: {
                    src: require("@/assets/image/login/assetLogin.svg"),
                  },
                })
              : _c("img", {
                  staticClass: "asset-img",
                  attrs: {
                    src: require("@/assets/image/login/assetLogout.svg"),
                  },
                }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }